import { render, staticRenderFns } from "./xiaoXi.vue?vue&type=template&id=2f9c7048&scoped=true"
import script from "./xiaoXi.vue?vue&type=script&lang=js"
export * from "./xiaoXi.vue?vue&type=script&lang=js"
import style0 from "./xiaoXi.vue?vue&type=style&index=0&id=2f9c7048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9c7048",
  null
  
)

export default component.exports